import { create } from 'zustand';

interface FileOpenRequest {
  /** Full path to the file to open */
  path: string;
  /** Project root to resolve relative paths against */
  projectRoot?: string;
  /** Timestamp to ensure uniqueness */
  timestamp: number;
}

interface FileOpenState {
  /** Pending file open request */
  pendingRequest: FileOpenRequest | null;

  /** Request to open a file in the Files panel */
  requestOpenFile: (path: string, projectRoot?: string) => void;

  /** Clear the pending request (called after file is opened) */
  clearRequest: () => void;
}

export const useFileOpenStore = create<FileOpenState>((set) => ({
  pendingRequest: null,

  requestOpenFile: (path, projectRoot) => {
    set({
      pendingRequest: {
        path,
        projectRoot,
        timestamp: Date.now(),
      },
    });
  },

  clearRequest: () => {
    set({ pendingRequest: null });
  },
}));
